import { Children, isValidElement } from 'react';
import DataSet from '../data-set/DataSet';
import { DataSetSelection, FieldType } from '../data-set/enum';
function getOptionsFromChildren(elements, data, fields, textField, valueField, parentField, idField, disabledField, parent) {
    if (elements) {
        Children.forEach(elements, child => {
            if (isValidElement(child)) {
                const { type } = child;
                if (type.__PRO_TREE_SELECT_NODE) {
                    const props = child.props;
                    const { value, title, children, disabled, ...__treeNodeProps } = props;
                    data.push({
                        [textField]: title,
                        [valueField]: value,
                        [disabledField]: disabled,
                        [parentField]: parent,
                        __treeNodeProps,
                    });
                    if (idField !== valueField) {
                        data[idField] = props[idField] || value;
                    }
                    getOptionsFromChildren(children, data, fields, textField, valueField, parentField, idField, disabledField, props[idField] || value);
                }
            }
        });
    }
}
export default function normalizeTreeNodes({ textField, valueField, disabledField, parentField, idField, multiple, children, }) {
    const data = [];
    const fields = [
        {
            name: textField,
            type: FieldType.reactNode,
        },
        {
            name: valueField,
        },
        {
            name: disabledField,
            type: FieldType.boolean,
        },
    ];
    if (children) {
        getOptionsFromChildren(children, data, fields, textField, valueField, parentField, idField, disabledField);
    }
    return new DataSet({
        data,
        fields,
        paging: false,
        selection: multiple ? DataSetSelection.multiple : DataSetSelection.single,
        autoLocateFirst: false,
        parentField,
        idField,
    });
}
